import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import clone from "clone";
import {
  Button,
  Container,
  Dimmer,
  Grid,
  Header,
  Icon,
  Loader,
  Segment,
} from "semantic-ui-react";
import { withTranslation } from 'react-i18next';
import qs from "qs";
import BookingTitle from "../../../components/Bookings/BookingTitle";
import BOOKING_DEFAULT from "../../../structs/booking";
import SecureDocumentsSharing from "../../Widgets/SecureDocumentsSharing";
import { fetchAPI, fetchM } from "../../../actions/fetchM";
import * as endpoints from "../../../constants/apiEndpoints";
import { flashErrorMessage } from "../../../actions/flash";

import { DEVELOPER_CANCELLED } from "../../../constants/lawyerCaseStatuses";
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';
import { isCountryVietnam } from '../../../constants/countries';
import SharedMediaDocuments from '../../Opportunities/Overview/Document';
import config from '../../../../config';
import {
  bookingUsesCurrentIdentityDocuments,
  getCurrentBookingIdentityDocuments,
} from './bookingCurrentIdentityDocuments';

class Documents extends Component {
  static contextTypes = {
    store: PropTypes.object,
  };
  static propTypes = {
    token: PropTypes.string,
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      creditCheckAccess: PropTypes.bool,
      allowEditUnitPrice: PropTypes.bool,
      allowEditUnitDetails: PropTypes.bool,
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
    }),
    onCheck: PropTypes.func,
    // CPI-1249: the Vietnam branch renders the shared-media table, fed by Bookings.jsx.
    documentData: PropTypes.oneOfType([PropTypes.array]),
    fetchDocument: PropTypes.func,
    parentType: PropTypes.string,
    parentID: PropTypes.string,
    opportunity: PropTypes.object,
    loading: PropTypes.bool,
    t: PropTypes.func,
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        noeticIsEnabled: PropTypes.bool,
        lawyerIsEnabled: PropTypes.bool,
      }),
    }),
    fetchNewBooking: PropTypes.func,
    isMobile: PropTypes.bool,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
      search: PropTypes.string,
    }).isRequired,
  };
  static mapStateToProps = (state) => ({
    auth: state.auth,
    appConfig: state.appConfig,
  });
  // CPI-1249: one predicate for the whole file; elsewhere the SecureDocuments widget is untouched.
  static isVietnam = props =>
    isCountryVietnam(props && props.auth && props.auth.company && props.auth.company.countryCode);
  static getPropsToState = (props) => {
    const data = Object.assign({}, BOOKING_DEFAULT, props.data);
    data.isCancelPending = true;

    let activeBankCodes = [];
    let activeBankers = [];
    if (!Documents.isVietnam(props) && data && data.bankCases && data.bankCases.length > 0) {
      for (let i = 0; i < data.bankCases.length; i += 1) {
        const bankCase = data.bankCases[i];
        if (bankCase.status.startsWith('new') ||
        bankCase.status.startsWith('pending') ||
        bankCase.status.startsWith('approved') ||
        bankCase.status.startsWith('success')) {
          activeBankCodes = activeBankCodes.concat(bankCase.code);
          if (bankCase.banker && bankCase.banker.user && bankCase.banker.user.awsUsername !== '' && bankCase.bank) {
            activeBankers = activeBankers.concat({
              value: bankCase.banker.user.awsUsername,
              label: bankCase.banker.preferredName || bankCase.banker.name,
              caption: bankCase.bank.name || 'Banker',
            });
          }
        }
      }
    }

    return {
      data,
      oriData: clone(data),
      assignedBankers: activeBankers,
      assignedBankCasesCode: activeBankCodes,
    };
  };
  constructor(props) {
    super(props);
    const state = Documents.getPropsToState(props);
    this.state = {
      ...state,
      loading: false,
      loaded: false,
      cases: {
        SPA: [],
        LA: [],
      },
      activeCase: {
        SPA: null,
        LA: null,
      },
      nextToken: {
        SPA: null,
        LA: null,
      },
      lawyerLoading: {
        SPA: null,
        LA: null,
      },
      lawyersIDList: [],
      lawyersList: [],
      assignedLawyers: [],
      assignedLawyerCasesID: [],
      // CPI-1249 / CPI-976: the wet-sign uploader is kept, collapsed, below the table.
      showWetSignUpload: false,
      currentIdentities: {},
      currentIdentityLoading: Documents.isVietnam(props) && !!state.data.purchasersIsolated,
    };
    this.currentIdentityLoad = 0;
    this.mounted = false;
  }
  componentDidMount() {
    this.mounted = true;
    if (Documents.isVietnam(this.props)) this.fetchCurrentIdentities(this.state.data);
    if (!Documents.isVietnam(this.props)) {
      this.fetchAllLawyerCasesDetails();
    }
  }
  componentWillReceiveProps(nextProps) {
    const state = Documents.getPropsToState(nextProps);
    // don't allow state to override data if oriData is same
    const isOriDataSame = JSON.stringify(this.state.oriData) === JSON.stringify(state.oriData);
    if (isOriDataSame) {
      state.data = this.state.data;
    }
    if (!isOriDataSame && Documents.isVietnam(nextProps)) {
      state.currentIdentities = {};
      state.currentIdentityLoading = !!state.data.purchasersIsolated;
    }
    this.setState({ ...state }, () => {
      if (!isOriDataSame && Documents.isVietnam(nextProps)) {
        this.fetchCurrentIdentities(this.state.data);
      }
      if (!isOriDataSame && !Documents.isVietnam(nextProps)) {
        this.fetchAllLawyerCasesDetails();
      }
    });
  }
  componentWillUnmount() {
    this.mounted = false;
    this.currentIdentityLoad += 1;
  }
  setComponentState = (state = {}) =>
    new Promise((res) => this.setState(state, () => res(state)));
  setCases = (type, data = [], token, loadMore) =>
    new Promise((res) => {
      const { cases, activeCase, nextToken, lawyersIDList } = this.state;
      const newData = data || [];
      newData.forEach((_data) => {
        const isExist = lawyersIDList.find((id) => id === _data.lawyer_id);
        if (!isExist) {
          lawyersIDList.push(_data.lawyer_id);
        }
      });
      const newCases = loadMore ? activeCase[type].concat(newData) : newData;
      let currentCase = newCases.find((d) => d.status !== DEVELOPER_CANCELLED);
      if (!activeCase) {
        currentCase = this.state.activeCase[type];
      }
      cases[type] = newCases;
      activeCase[type] = currentCase;
      nextToken[type] = token;
      this.setState({ cases, activeCase, nextToken, lawyersIDList }, () =>
        res(newCases),
      );
    });

  setLoading = (newLoading = false, type) =>
    new Promise((res) => {
      const { lawyerLoading } = this.state;
      if (type != null) {
        lawyerLoading[type] = newLoading;
      } else {
        lawyerLoading.SPA = newLoading;
        lawyerLoading.LA = newLoading;
      }
      this.setState({ lawyerLoading }, () => res(newLoading));
    });

  fetchCurrentIdentities = async (booking) => {
    const load = this.currentIdentityLoad + 1;
    this.currentIdentityLoad = load;
    const { store } = this.context;
    const customers = booking && booking.purchasersIsolated && booking.id ?
      (booking.bookingCustomers || []) : [];
    if (customers.length === 0) {
      if (this.mounted && load === this.currentIdentityLoad) {
        this.setState({ currentIdentities: {}, currentIdentityLoading: false });
      }
      return;
    }

    this.setState({ currentIdentities: {}, currentIdentityLoading: true });
    const options = { credentials: 'include', method: 'GET', ignoreNotFound: true, ignoreForbidden: true };
    const entries = await Promise.all(customers.map(async (bookingCustomer) => {
      const customerID = bookingCustomer && bookingCustomer.customerID;
      if (!customerID) return null;
      try {
        const res = await store.dispatch(fetchM(`/bookings/${booking.id}/customers/${customerID}/crm_identity/?metadata=1`, options));
        if (!res || !res.ok) return [customerID, { status: 'error' }];
        return [customerID, await res.json()];
      } catch (err) {
        return [customerID, { status: 'error' }];
      }
    }));
    if (!this.mounted || load !== this.currentIdentityLoad || String(this.state.data.id) !== String(booking.id)) return;
    const currentIdentities = entries.filter(Boolean).reduce((result, entry) => {
      result[entry[0]] = entry[1];
      return result;
    }, {});
    this.setState({ currentIdentities, currentIdentityLoading: false });
  }

  getLawyers() {
    const { activeCase, lawyersList } = this.state;
    let activeLawyers = [];
    const activeCasesIDs = [];
    if (activeCase && lawyersList && lawyersList.length > 0) {
      activeLawyers = lawyersList.reduce((result, lawyer) => {
        if (!lawyer) {
          return result;
        }
        if (activeCase.SPA && activeCase.SPA.lawyer_id === lawyer.id) {
          result.push({
            value: lawyer.id,
            label: lawyer.name,
            caption: 'SPA Lawyer',
          });
        }
        if (activeCase.LA && activeCase.LA.lawyer_id === lawyer.id) {
          result.push({
            value: lawyer.id,
            label: lawyer.name,
            caption: 'LA Lawyer',
          });
        }
        return result;
      }, []);
    }

    activeCase && activeCase.SPA ? activeCasesIDs.push(activeCase.SPA.id) : '';
    activeCase && activeCase.LA ? activeCasesIDs.push(activeCase.LA.id) : '';

    this.setState({ assignedLawyers: activeLawyers, assignedLawyerCasesID: activeCasesIDs });
  }

  fetchAllLawyerCasesDetails = async () => {
    const { data, lawyersIDList } = this.state;
    if (data && data.id) {
      const promiseArr = [
        this.fetchLawyerCases('SPA', null, data.id),
        this.fetchLawyerCases('LA', null, data.id),
      ];
      if (promiseArr.length > 0) {
        await Promise.all(promiseArr);
        const promiseArrLawyer = [];
        lawyersIDList.forEach((id) => {
          promiseArrLawyer.push(this.fetchLawyer(id));
        });
        const promiseResultArray = await Promise.all(promiseArrLawyer);
        this.setState({ lawyersList: promiseResultArray }, this.getLawyers);
      }
    }
  };

  async fetchLawyer(lawyerID = null) {
    if (!lawyerID) return null;
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(
        fetchAPI('lawyerAPI', endpoints.LAWYER(lawyerID), null, 'get', {
          'X-Api-Token': process.env.LAWYER_API_TOKEN,
        }),
      );
      return res;
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(
        flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }),
      );
      return null;
    }
  }

  fetchLawyerCases = async (
    type,
    nextToken,
    bookingID = this.state.data.bookingID,
  ) => {
    await this.setLoading(true, type);
    if (!nextToken) {
      const { activeCase } = this.state;
      activeCase[type] = null;
      await this.setComponentState({ activeCase });
    }
    const { store } = this.context;
    const { t } = this.props;
    const query = {
      limit: 10,
      type,
    };
    if (nextToken) {
      query.next_token = nextToken;
    }
    let res;
    try {
      res = await store.dispatch(
        fetchAPI(
          'lawyerAPI',
          `${endpoints.BOOKING_CASES(bookingID)}/?${qs.stringify(query)}`,
          null,
          'get',
          {
            'X-Api-Token': process.env.LAWYER_API_TOKEN,
          },
        ),
      );
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(
        flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }),
      );
      await this.setLoading(false, type);
      return;
    }

    if (res) {
      await this.setCases(type, res.items, res.next_token, !!nextToken);
    }

    await this.setLoading(false, type);
  };

  handleToggleWetSignUpload = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    this.setState(prevState => ({ showWetSignUpload: !prevState.showWetSignUpload }));
  };

  // CPI-1249: Vietnam's Documents tab is the shared-media table with CPI-976's wet-sign uploader
  // kept below it - the only place a `signed_sales_form_wet` document can be produced.
  renderVietnam() {
    const {
      data, showWetSignUpload, assignedBankers, assignedBankCasesCode,
      assignedLawyers, assignedLawyerCasesID, currentIdentities, currentIdentityLoading,
    } = this.state;
    const {
      t, auth, location, loading, documentData, fetchDocument, parentType, parentID, token, opportunity,
    } = this.props;
    const currentIdentityMode = bookingUsesCurrentIdentityDocuments(data);
    const currentIdentityDocuments = getCurrentBookingIdentityDocuments(
      data,
      currentIdentities,
      currentIdentityLoading,
      config.get('bookApiURL'),
    );
    return (
      <Container className="no_margin">
        <BookingTitle isMobile={this.props.isMobile} data={data} />
        <Grid>
          <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
            <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
          </Dimmer>
          <Grid.Row>
            <Grid.Column width={16}>
              <Segment attached>
                <SharedMediaDocuments
                  auth={auth}
                  location={location}
                  loading={loading}
                  documentData={documentData}
                  fetchDocument={fetchDocument}
                  parentType={parentType}
                  parentID={parentID}
                  id={parentID}
                  mediaToken={token}
                  opportunity={opportunity}
                  currentIdentityMode={currentIdentityMode}
                  currentIdentityDocuments={currentIdentityDocuments}
                  currentIdentityBookingID={data.id}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <Button
                basic
                fluid
                onClick={this.handleToggleWetSignUpload}
                aria-expanded={showWetSignUpload}
              >
                <Icon name={showWetSignUpload ? 'chevron up' : 'chevron down'} />
                {t('Signed Sales Form (Wet Sign)', { ns: TRANSLATION_FILES.screens })}
              </Button>
              {showWetSignUpload && data && (
                <Segment attached>
                  <SecureDocumentsSharing
                    bookingID={data.id}
                    assignedBankers={assignedBankers}
                    assignedBankCasesCode={assignedBankCasesCode}
                    assignedLawyers={assignedLawyers}
                    assignedLawyerCasesID={assignedLawyerCasesID}
                    loanTrackerLeadCode={data.loanTrackerLeadCode}
                    isVietnam
                  />
                </Segment>
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }

  render() {
    const {
      assignedBankers,
      assignedBankCasesCode,
      assignedLawyers,
      assignedLawyerCasesID,
      data,
    } = this.state;
    const { t, auth } = this.props;
    if (Documents.isVietnam(this.props)) {
      return this.renderVietnam();
    }
    return (
      <Container className="no_margin">
        <BookingTitle isMobile={this.props.isMobile} data={data} />
        <Grid>
          <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
            <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
          </Dimmer>
          <Grid.Row>
            <Grid.Column width={16}>
              <Header
                className="new_title"
                as="h5"
                textAlign="center"
                attached="top"
              >
                {t('Document Sharing').toUpperCase()}
              </Header>
              <Segment attached>
                {data && (
                  <SecureDocumentsSharing
                    bookingID={data.id}
                    assignedBankers={assignedBankers}
                    assignedBankCasesCode={assignedBankCasesCode}
                    assignedLawyers={assignedLawyers}
                    assignedLawyerCasesID={assignedLawyerCasesID}
                    loanTrackerLeadCode={data.loanTrackerLeadCode}
                    isVietnam={isCountryVietnam(auth && auth.company && auth.company.countryCode)}
                  />
                )}
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default withTranslation(namespaces)(connect(Documents.mapStateToProps)(Documents));



// WEBPACK FOOTER //
// ./src/containers/Bookings/Overview/Documents.jsx